// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dmn-decision-table-container {
  --action-icon-color: var(--color-blue-205-100-50);
  --action-icon-background-color: transparent;
  --action-icon-hover-background-color: var(--color-blue-205-100-45);
  --action-icon-hover-color: var(--color-white);
  --add-column-icon-color: var(--color-white);
  --add-column-icon-background-color: var(--color-grey-225-10-35);
  --decision-table-color: var(--color-grey-225-10-15);
  --decision-table-background-color: var(--color-white);
  --decision-table-properties-color: var(--color-grey-225-10-15);
  --dmn-expression-language-background-color: var(--color-blue-205-100-45-opacity-30);
  --dmn-expression-language-color: var(--color-white);
  --dmn-expression-language-hover-background-color: var(--color-blue-205-100-50);
  --drag-and-drop-drag-color: var(--color-grey-225-10-55);
  --drag-and-drop-drop-marker-color: var(--color-grey-225-10-35);
  --hit-policy-explanation-color: var(--color-grey-225-10-35);
  --powered-by-overlay-background-color: var(--color-black-opacity-20);
  --powered-by-overlay-content-background-color: var(--color-white);
  --powered-by-overlay-content-color: var(--color-grey-225-10-15);
  --powered-by-overlay-content-border-color: var(--color-grey-225-10-75);
  --simple-mode-button-color: var(--color-grey-225-10-15);
  --simple-mode-button-background-color: var(--color-grey-225-10-97);
  --simple-mode-button-border-color: var(--color-grey-225-10-75);
  --simple-mode-button-box-shadow-color: var(--color-black-opacity-10);
  --simple-mode-button-disabled-color: var(--color-grey-225-10-75);
  --table-cell-color: var(--color-grey-225-10-15);
  --table-cell-border-color: var(--color-grey-225-10-15);
  --table-cell-selected-outline-color: var(--color-blue-205-100-45);
  --table-foot-add-rule-border-color: var(--color-grey-225-10-75);
  --table-foot-add-rule-color: var(--color-grey-225-10-75);
  --table-foot-add-rule-hover-border-color: var(--color-grey-225-10-15);
  --table-foot-add-rule-hover-color: var(--color-grey-225-10-15);
  --table-head-border-color: var(--color-grey-225-10-15);
  --table-head-clause-color: var(--color-grey-225-10-35);
  --table-head-separator-color: var(--color-grey-225-10-75);
  --table-head-variable-color: var(--color-grey-225-10-35);
  --table-row-alternative-background-color: var(--color-grey-225-10-97);
  --view-drd-button-background-color: var(--color-white);
  --view-drd-button-border-color: var(--color-grey-225-10-75);
  --view-drd-button-color: var(--color-grey-225-10-15);
  --view-drd-button-hover-background-color: var(--color-grey-225-10-97);
  --decision-table-font-family: 'Arial', sans-serif;

  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  font-family: var(--decision-table-font-family);
  font-size: 14px;
  color: var(--table-color);
  max-height: 100%;
}

/* basic styles */

.dmn-decision-table-container * {
  box-sizing: border-box;
}

.dmn-decision-table-container .tjs-container {
  display: flex;
  flex-direction: column;
  width: min-content;
  max-width: 100%;
  height: 100%;
}

/* end basic styles */

/* basic table styles */

.dmn-decision-table-container .tjs-table-container {
  overflow: auto;
  border: solid 1px var(--table-cell-border-color);
  border-top: none;
}

.dmn-decision-table-container .tjs-table {
  max-width: 100%;
  max-height: 100%;
  position: relative;
  width: 100%; /* Fallback for legacy Edge */
  width: min-content;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
}

.dmn-decision-table-container th,
.dmn-decision-table-container td {
  position: relative;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  background-clip: padding-box;
}

.dmn-decision-table-container thead th {
  text-align: center;
  width: 192px;
  font-weight: normal;
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: var(--decision-table-background-color);
  border-bottom: 3px double var(--table-head-border-color);
}

.dmn-decision-table-container thead th.output-editor {
  z-index: 2;
}

.dmn-decision-table-container thead th.create-inputs,
.dmn-decision-table-container thead th.input-editor {
  z-index: 3;
}

.dmn-decision-table-container tbody td {
  border-top: solid 1px var(--table-cell-border-color);
}

.dmn-decision-table-container th.input-cell,
.dmn-decision-table-container td.input-cell,
.dmn-decision-table-container th.output-cell,
.dmn-decision-table-container td.output-cell,
.dmn-decision-table-container th.annotation,
.dmn-decision-table-container td.annotation {
  color: var(--table-cell-color);
}

.dmn-decision-table-container th.input-cell + th.output-cell,
.dmn-decision-table-container td.input-cell + td.output-cell {
  border-left: 3px double var(--table-cell-border-color);
}

.dmn-decision-table-container th:not(:first-child),
.dmn-decision-table-container td:not(:first-child) {
  padding: 4px;
  border-left: solid 1px var(--table-cell-border-color);
}

.dmn-decision-table-container thead {
  background-color: var(--decision-table-background-color);
}

.dmn-decision-table-container thead th:first-child {
  left: 0;
  z-index: 4;
}

.dmn-decision-table-container tfoot td:first-child {
  border-right: solid 1px var(--table-foot-add-rule-border-color);
}

.dmn-decision-table-container tbody td:first-child,
.dmn-decision-table-container tfoot td:first-child {
  position: sticky;
  left: 0;
  background-color: var(--decision-table-background-color);
  z-index: 1;
}

.dmn-decision-table-container tbody:empty {
  display: none;
}

.dmn-decision-table-container thead th:first-child,
.dmn-decision-table-container tbody td:first-child {
  border-right: solid 1px var(--table-cell-border-color);
}

.dmn-decision-table-container thead th:nth-child(2),
.dmn-decision-table-container tbody td:nth-child(2),
.dmn-decision-table-container tfoot td:nth-child(2) {
  border-left: none;
}

.dmn-decision-table-container tbody tr:last-child td {
  border-bottom: solid 1px var(--table-cell-border-color);
}

.dmn-decision-table-container tbody tr:first-child td {
  border-top: none;
}

.dmn-decision-table-container th.index-column {
  width: 56px;
}

.dmn-decision-table-container td.rule-index {
  text-align: right;
  padding-right: 8px;
}

.dmn-decision-table-container tbody tr:nth-child(2n) {
  background-color: var(--table-row-alternative-background-color);
}

.dmn-decision-table-container td.input-cell.add-rule,
.dmn-decision-table-container td.input-cell:not(.focussed).empty {
  text-align: center;
}

/* end basic table styles */

/* selection styles */

.dmn-decision-table-container h3,
.dmn-decision-table-container h5 {
  position: relative;
}

.dmn-decision-table-container .selected {
  outline: var(--table-cell-selected-outline-color);
  outline-offset: -1px;
}

.dmn-decision-table-container th.selected:not(.focussed) {
  background: var(--selected-not-focused-border-color);
}

/* end selection styles */

/* footer styles */

.dmn-decision-table-container tfoot td.input-cell + td.output-cell {
  border-left: 3px double var(--table-foot-add-rule-border-color);
}

.dmn-decision-table-container tfoot.add-rule td.add-rule-add {
  text-align: right;
  padding-right: 4px;
}

.dmn-decision-table-container tfoot.add-rule tr td {
  border-color: var(--table-foot-add-rule-border-color);
  color: var(--table-foot-add-rule-color);
}

.dmn-decision-table-container tfoot.add-rule:hover td.input-cell + td.output-cell {
  border-left-color: var(--table-cell-border-color);
}

.dmn-decision-table-container tfoot.add-rule:hover td {
  border-color: var(--table-foot-add-rule-hover-border-color);
  color: var(--table-foot-add-rule-hover-color);
}

/* end footer styles */

/* content editable styles */

.dmn-decision-table-container [contenteditable],
.dmn-decision-table-container [tabindex] {
  outline: none;
}

/* end content editable styles */

/* decision table header */
.dmn-decision-table-container .decision-table-header {
  text-align: left;
  padding: 10px;
}

.dmn-decision-table-container .decision-table-header * {
  vertical-align: middle;
}

/* decision table properties */
.dmn-decision-table-container .decision-table-properties {
  display: flex;
  color: var(--decision-table-properties-color);
  border: 1px solid var(--table-cell-border-color);
  background-color: var(--decision-table-background-color);
  padding: 10px;
  align-items: center;
}

.dmn-decision-table-container .decision-table-name {
  position: relative;
  display: block;
  flex-grow: 1;
  margin: 0;
  width: 0;
  min-width: 100px;
  max-width: min-content;
  font-size: 21px;
  font-weight: normal;
}

.dmn-decision-table-container .decision-table-name:not(.editable),
.dmn-decision-table-container .decision-table-name .content-editable {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.dmn-decision-table-container .decision-table-name.focussed .content-editable {
  text-overflow: unset;
}

.dmn-decision-table-container .decision-table-header-separator {
  display: block;
  height: 32px;
  border-left: 2px solid var(--table-head-separator-color);
  margin: 0 10px;
}

.dmn-decision-table-container .hit-policy {
  display: block;
}

.dmn-decision-table-container .hit-policy-explanation {
  margin-left: 5px;
  color: var(--hit-policy-explanation-color);
}

/* end decision table properties */

.dmn-decision-table-container thead .input-label,
.dmn-decision-table-container thead .input-expression,
.dmn-decision-table-container thead .output-label,
.dmn-decision-table-container thead .output-name {
  display: -webkit-box;
  margin: 16px 6px;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.dmn-decision-table-container thead .input-expression:empty::before {
  content: 'Input';
  opacity: 0.5;
}

.dmn-decision-table-container thead .output-name:empty::before {
  content: 'Output';
  opacity: 0.5;
}

.dmn-decision-table-container thead .input-variable,
.dmn-decision-table-container thead .output-variable {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: right;
}

.dmn-decision-table-container thead .input-cell .clause,
.dmn-decision-table-container thead .output-cell .clause {
  font-size: 12px;
  text-align: left;
  color: var(--table-head-clause-color);
}

.dmn-decision-table-container thead .input-cell .input-variable,
.dmn-decision-table-container thead .output-cell .output-variable {
  font-size: 12px;
  color: var(--table-head-variable-color);
}

/* actionable icon */

.dmn-decision-table-container .action-icon {
  border: none;
  border-radius: 2px;
  box-shadow: 0 0 0 2px var(--decision-table-background-color);
  color: var(--action-icon-color);
  background-color: var(--action-icon-background-color);
  padding: 0;
}

.dmn-decision-table-container .create-inputs .action-icon,
.dmn-decision-table-container .add-input .action-icon,
.dmn-decision-table-container .add-output .action-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin: 0;
  border-radius: 50%;
  color: var(--add-column-icon-color);
  background-color: var(--add-column-icon-background-color);
  outline-offset: 4px;
}

.dmn-decision-table-container .actionable:hover .action-icon {
  background-color: var(--action-icon-hover-background-color);
  color: var(--action-icon-hover-color);
}

.dmn-decision-table-container .action-icon::before {
  margin-left: 0.1em;
  margin-right: 0.1em;
}

.dmn-decision-table-container .add-input,
.dmn-decision-table-container .add-output {
  position: absolute;
  top: 50%;
  right: -1px;
  transform: translate(50%, -50%);
  z-index: 2;
  border-radius: 100%;
  padding: 6px;
}

/* end actionable icon */

/* view drd */
.dmn-decision-table-container .view-drd {
  margin-bottom: 10px;
}

.dmn-decision-table-container .view-drd .view-drd-button {
  background: var(--view-drd-button-background-color);
  padding: 8px;
  border: solid 1px var(--view-drd-button-border-color);
  border-radius: 2px;
  font-size: 14px;
  color: var(--view-drd-button-color);
  font-weight: bold;
  cursor: pointer;
}

.dmn-decision-table-container .view-drd .view-drd-button:hover {
  background: var(--view-drd-button-hover-background-color);
}

/* end view drd */

/* simple mode */

.dmn-decision-table-container .simple-mode-button {
  color: var(--simple-mode-button-color);
  background-color: var(--simple-mode-button-background-color);
  position: absolute;
  padding: 4px;
  border-radius: 2px;
  border: solid 1px var(--simple-mode-button-border-color);
  cursor: pointer;
  font-size: 14px;
  z-index: 5;
  opacity: 0.8;
  box-shadow: 1px 1px 1px 1px var(--simple-mode-button-box-shadow-color);
}

.dmn-decision-table-container .simple-mode-button:hover {
  opacity: 1;
}

.dmn-decision-table-container .simple-mode-button.disabled,
.dmn-decision-table-container .simple-mode-button.disabled:hover {
  color: var(--simple-mode-button-disabled-olor);
}

.dmn-decision-table-container .dms-input-duration-edit-row {
  align-items: flex-start;
}

/* end simple mode  */

/* badges */

.dms-badge {
  border-radius: 2px;
  padding: 3px 6px;
  font-size: 0.8em;
  height: 19px;
}

.dms-badge-icon + .dms-badge-label {
  margin-left: 3px;
}

.dms-badge.dmn-expression-language {
  background: var(--dmn-expression-language-background-color);
  color: var(--dmn-expression-language-color);
}

.dms-badge + .dms-badge {
  margin-left: 3px;
}

.dmn-decision-table-container .dmn-expression-language .dms-badge-label {
  display: none;
}

.dmn-decision-table-container .input-cell:hover .dmn-expression-language .dms-badge-label,
.dmn-decision-table-container .output-cell:hover .dmn-expression-language .dms-badge-label {
  display: inline-block;
}

.dmn-decision-table-container .input-editor .dmn-expression-language {
  margin-top: 4px;
  display: inline-block;
}

.dmn-decision-table-container .cell .dms-badge.dmn-expression-language {
  z-index: -1;
}

.dmn-decision-table-container .cell:hover .dms-badge.dmn-expression-language {
  background: var(--dmn-expression-language-hover-background-color);
  z-index: 1;
}

/* cell expression language */

.dmn-decision-table-container .cell .dmn-expression-language {
  display: flex;
  align-items: center;
  position: absolute;
  top: 2px;
  right: 2px;
  pointer-events: none;
}

/* end cell expression language */

/* drag and drop */

.dmn-decision-table-container .dragover::before {
  content: '';
  display: block;
  position: absolute;
  background-color: var(--drag-and-drop-drop-marker-color);
  z-index: 2;
  pointer-events: none;
}

.dmn-decision-table-container .dragover.top::before {
  left: 0;
  right: 0;
  height: 5px;
  top: 0;
}

.dmn-decision-table-container .dragover.right::before {
  top: 0;
  bottom: 0;
  width: 5px;
  right: 0;
}

.dmn-decision-table-container .dragover.bottom::before {
  left: 0;
  right: 0;
  height: 5px;
  bottom: 0;
}

.dmn-decision-table-container .dragover.left::before {
  top: 0;
  bottom: 0;
  width: 5px;
  left: 0;
}

.dmn-decision-table-container .dragged {
  color: var(--drag-and-drop-drag-color);
}

/* cell description */

.dmn-decision-table-container .description-indicator {
  position: absolute;
  top: 0;
  right: -4px;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid var(--color-black);
  transform: rotate(45deg);
  transform-origin: top;
}

/* end cell description */
`, "",{"version":3,"sources":["webpack://./node_modules/dmn-js/dist/assets/dmn-js-decision-table.css"],"names":[],"mappings":"AAAA;EACE,iDAAiD;EACjD,2CAA2C;EAC3C,kEAAkE;EAClE,6CAA6C;EAC7C,2CAA2C;EAC3C,+DAA+D;EAC/D,mDAAmD;EACnD,qDAAqD;EACrD,8DAA8D;EAC9D,mFAAmF;EACnF,mDAAmD;EACnD,8EAA8E;EAC9E,uDAAuD;EACvD,8DAA8D;EAC9D,2DAA2D;EAC3D,oEAAoE;EACpE,iEAAiE;EACjE,+DAA+D;EAC/D,sEAAsE;EACtE,uDAAuD;EACvD,kEAAkE;EAClE,8DAA8D;EAC9D,oEAAoE;EACpE,gEAAgE;EAChE,+CAA+C;EAC/C,sDAAsD;EACtD,iEAAiE;EACjE,+DAA+D;EAC/D,wDAAwD;EACxD,qEAAqE;EACrE,8DAA8D;EAC9D,sDAAsD;EACtD,sDAAsD;EACtD,yDAAyD;EACzD,wDAAwD;EACxD,qEAAqE;EACrE,sDAAsD;EACtD,2DAA2D;EAC3D,oDAAoD;EACpD,qEAAqE;EACrE,iDAAiD;;EAEjD,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;EAC9C,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,iBAAiB;;AAEjB;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA,qBAAqB;;AAErB,uBAAuB;;AAEvB;EACE,cAAc;EACd,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW,EAAE,6BAA6B;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,wDAAwD;EACxD,wDAAwD;AAC1D;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,oDAAoD;AACtD;;AAEA;;;;;;EAME,8BAA8B;AAChC;;AAEA;;EAEE,sDAAsD;AACxD;;AAEA;;EAEE,YAAY;EACZ,qDAAqD;AACvD;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,+DAA+D;AACjE;;AAEA;;EAEE,gBAAgB;EAChB,OAAO;EACP,wDAAwD;EACxD,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,sDAAsD;AACxD;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,+DAA+D;AACjE;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA,2BAA2B;;AAE3B,qBAAqB;;AAErB;;EAEE,kBAAkB;AACpB;;AAEA;EACE,iDAAiD;EACjD,oBAAoB;AACtB;;AAEA;EACE,oDAAoD;AACtD;;AAEA,yBAAyB;;AAEzB,kBAAkB;;AAElB;EACE,+DAA+D;AACjE;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,uCAAuC;AACzC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,2DAA2D;EAC3D,6CAA6C;AAC/C;;AAEA,sBAAsB;;AAEtB,4BAA4B;;AAE5B;;EAEE,aAAa;AACf;;AAEA,gCAAgC;;AAEhC,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,6CAA6C;EAC7C,gDAAgD;EAChD,wDAAwD;EACxD,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,wDAAwD;EACxD,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA,kCAAkC;;AAElC;;;;EAIE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;;EAEE,eAAe;EACf,uCAAuC;AACzC;;AAEA,oBAAoB;;AAEpB;EACE,YAAY;EACZ,kBAAkB;EAClB,4DAA4D;EAC5D,+BAA+B;EAC/B,qDAAqD;EACrD,UAAU;AACZ;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,yDAAyD;EACzD,mBAAmB;AACrB;;AAEA;EACE,2DAA2D;EAC3D,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,+BAA+B;EAC/B,UAAU;EACV,mBAAmB;EACnB,YAAY;AACd;;AAEA,wBAAwB;;AAExB,aAAa;AACb;EACE,mBAAmB;AACrB;;AAEA;EACE,mDAAmD;EACnD,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;EAClB,eAAe;EACf,mCAAmC;EACnC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yDAAyD;AAC3D;;AAEA,iBAAiB;;AAEjB,gBAAgB;;AAEhB;EACE,sCAAsC;EACtC,4DAA4D;EAC5D,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,wDAAwD;EACxD,eAAe;EACf,eAAe;EACf,UAAU;EACV,YAAY;EACZ,sEAAsE;AACxE;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;AACzB;;AAEA,qBAAqB;;AAErB,WAAW;;AAEX;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2DAA2D;EAC3D,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iEAAiE;EACjE,UAAU;AACZ;;AAEA,6BAA6B;;AAE7B;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;AACtB;;AAEA,iCAAiC;;AAEjC,kBAAkB;;AAElB;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,wDAAwD;EACxD,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,WAAW;EACX,MAAM;AACR;;AAEA;EACE,MAAM;EACN,SAAS;EACT,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,WAAW;EACX,SAAS;AACX;;AAEA;EACE,MAAM;EACN,SAAS;EACT,UAAU;EACV,OAAO;AACT;;AAEA;EACE,sCAAsC;AACxC;;AAEA,qBAAqB;;AAErB;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,kCAAkC;EAClC,mCAAmC;EACnC,2CAA2C;EAC3C,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,yBAAyB","sourcesContent":[".dmn-decision-table-container {\r\n  --action-icon-color: var(--color-blue-205-100-50);\r\n  --action-icon-background-color: transparent;\r\n  --action-icon-hover-background-color: var(--color-blue-205-100-45);\r\n  --action-icon-hover-color: var(--color-white);\r\n  --add-column-icon-color: var(--color-white);\r\n  --add-column-icon-background-color: var(--color-grey-225-10-35);\r\n  --decision-table-color: var(--color-grey-225-10-15);\r\n  --decision-table-background-color: var(--color-white);\r\n  --decision-table-properties-color: var(--color-grey-225-10-15);\r\n  --dmn-expression-language-background-color: var(--color-blue-205-100-45-opacity-30);\r\n  --dmn-expression-language-color: var(--color-white);\r\n  --dmn-expression-language-hover-background-color: var(--color-blue-205-100-50);\r\n  --drag-and-drop-drag-color: var(--color-grey-225-10-55);\r\n  --drag-and-drop-drop-marker-color: var(--color-grey-225-10-35);\r\n  --hit-policy-explanation-color: var(--color-grey-225-10-35);\r\n  --powered-by-overlay-background-color: var(--color-black-opacity-20);\r\n  --powered-by-overlay-content-background-color: var(--color-white);\r\n  --powered-by-overlay-content-color: var(--color-grey-225-10-15);\r\n  --powered-by-overlay-content-border-color: var(--color-grey-225-10-75);\r\n  --simple-mode-button-color: var(--color-grey-225-10-15);\r\n  --simple-mode-button-background-color: var(--color-grey-225-10-97);\r\n  --simple-mode-button-border-color: var(--color-grey-225-10-75);\r\n  --simple-mode-button-box-shadow-color: var(--color-black-opacity-10);\r\n  --simple-mode-button-disabled-color: var(--color-grey-225-10-75);\r\n  --table-cell-color: var(--color-grey-225-10-15);\r\n  --table-cell-border-color: var(--color-grey-225-10-15);\r\n  --table-cell-selected-outline-color: var(--color-blue-205-100-45);\r\n  --table-foot-add-rule-border-color: var(--color-grey-225-10-75);\r\n  --table-foot-add-rule-color: var(--color-grey-225-10-75);\r\n  --table-foot-add-rule-hover-border-color: var(--color-grey-225-10-15);\r\n  --table-foot-add-rule-hover-color: var(--color-grey-225-10-15);\r\n  --table-head-border-color: var(--color-grey-225-10-15);\r\n  --table-head-clause-color: var(--color-grey-225-10-35);\r\n  --table-head-separator-color: var(--color-grey-225-10-75);\r\n  --table-head-variable-color: var(--color-grey-225-10-35);\r\n  --table-row-alternative-background-color: var(--color-grey-225-10-97);\r\n  --view-drd-button-background-color: var(--color-white);\r\n  --view-drd-button-border-color: var(--color-grey-225-10-75);\r\n  --view-drd-button-color: var(--color-grey-225-10-15);\r\n  --view-drd-button-hover-background-color: var(--color-grey-225-10-97);\r\n  --decision-table-font-family: 'Arial', sans-serif;\r\n\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: hidden;\r\n  position: relative;\r\n  font-family: var(--decision-table-font-family);\r\n  font-size: 14px;\r\n  color: var(--table-color);\r\n  max-height: 100%;\r\n}\r\n\r\n/* basic styles */\r\n\r\n.dmn-decision-table-container * {\r\n  box-sizing: border-box;\r\n}\r\n\r\n.dmn-decision-table-container .tjs-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: min-content;\r\n  max-width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n/* end basic styles */\r\n\r\n/* basic table styles */\r\n\r\n.dmn-decision-table-container .tjs-table-container {\r\n  overflow: auto;\r\n  border: solid 1px var(--table-cell-border-color);\r\n  border-top: none;\r\n}\r\n\r\n.dmn-decision-table-container .tjs-table {\r\n  max-width: 100%;\r\n  max-height: 100%;\r\n  position: relative;\r\n  width: 100%; /* Fallback for legacy Edge */\r\n  width: min-content;\r\n  table-layout: fixed;\r\n  border-collapse: separate;\r\n  border-spacing: 0;\r\n}\r\n\r\n.dmn-decision-table-container th,\r\n.dmn-decision-table-container td {\r\n  position: relative;\r\n  white-space: pre-wrap;\r\n  overflow-wrap: break-word;\r\n  background-clip: padding-box;\r\n}\r\n\r\n.dmn-decision-table-container thead th {\r\n  text-align: center;\r\n  width: 192px;\r\n  font-weight: normal;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 1;\r\n  background-color: var(--decision-table-background-color);\r\n  border-bottom: 3px double var(--table-head-border-color);\r\n}\r\n\r\n.dmn-decision-table-container thead th.output-editor {\r\n  z-index: 2;\r\n}\r\n\r\n.dmn-decision-table-container thead th.create-inputs,\r\n.dmn-decision-table-container thead th.input-editor {\r\n  z-index: 3;\r\n}\r\n\r\n.dmn-decision-table-container tbody td {\r\n  border-top: solid 1px var(--table-cell-border-color);\r\n}\r\n\r\n.dmn-decision-table-container th.input-cell,\r\n.dmn-decision-table-container td.input-cell,\r\n.dmn-decision-table-container th.output-cell,\r\n.dmn-decision-table-container td.output-cell,\r\n.dmn-decision-table-container th.annotation,\r\n.dmn-decision-table-container td.annotation {\r\n  color: var(--table-cell-color);\r\n}\r\n\r\n.dmn-decision-table-container th.input-cell + th.output-cell,\r\n.dmn-decision-table-container td.input-cell + td.output-cell {\r\n  border-left: 3px double var(--table-cell-border-color);\r\n}\r\n\r\n.dmn-decision-table-container th:not(:first-child),\r\n.dmn-decision-table-container td:not(:first-child) {\r\n  padding: 4px;\r\n  border-left: solid 1px var(--table-cell-border-color);\r\n}\r\n\r\n.dmn-decision-table-container thead {\r\n  background-color: var(--decision-table-background-color);\r\n}\r\n\r\n.dmn-decision-table-container thead th:first-child {\r\n  left: 0;\r\n  z-index: 4;\r\n}\r\n\r\n.dmn-decision-table-container tfoot td:first-child {\r\n  border-right: solid 1px var(--table-foot-add-rule-border-color);\r\n}\r\n\r\n.dmn-decision-table-container tbody td:first-child,\r\n.dmn-decision-table-container tfoot td:first-child {\r\n  position: sticky;\r\n  left: 0;\r\n  background-color: var(--decision-table-background-color);\r\n  z-index: 1;\r\n}\r\n\r\n.dmn-decision-table-container tbody:empty {\r\n  display: none;\r\n}\r\n\r\n.dmn-decision-table-container thead th:first-child,\r\n.dmn-decision-table-container tbody td:first-child {\r\n  border-right: solid 1px var(--table-cell-border-color);\r\n}\r\n\r\n.dmn-decision-table-container thead th:nth-child(2),\r\n.dmn-decision-table-container tbody td:nth-child(2),\r\n.dmn-decision-table-container tfoot td:nth-child(2) {\r\n  border-left: none;\r\n}\r\n\r\n.dmn-decision-table-container tbody tr:last-child td {\r\n  border-bottom: solid 1px var(--table-cell-border-color);\r\n}\r\n\r\n.dmn-decision-table-container tbody tr:first-child td {\r\n  border-top: none;\r\n}\r\n\r\n.dmn-decision-table-container th.index-column {\r\n  width: 56px;\r\n}\r\n\r\n.dmn-decision-table-container td.rule-index {\r\n  text-align: right;\r\n  padding-right: 8px;\r\n}\r\n\r\n.dmn-decision-table-container tbody tr:nth-child(2n) {\r\n  background-color: var(--table-row-alternative-background-color);\r\n}\r\n\r\n.dmn-decision-table-container td.input-cell.add-rule,\r\n.dmn-decision-table-container td.input-cell:not(.focussed).empty {\r\n  text-align: center;\r\n}\r\n\r\n/* end basic table styles */\r\n\r\n/* selection styles */\r\n\r\n.dmn-decision-table-container h3,\r\n.dmn-decision-table-container h5 {\r\n  position: relative;\r\n}\r\n\r\n.dmn-decision-table-container .selected {\r\n  outline: var(--table-cell-selected-outline-color);\r\n  outline-offset: -1px;\r\n}\r\n\r\n.dmn-decision-table-container th.selected:not(.focussed) {\r\n  background: var(--selected-not-focused-border-color);\r\n}\r\n\r\n/* end selection styles */\r\n\r\n/* footer styles */\r\n\r\n.dmn-decision-table-container tfoot td.input-cell + td.output-cell {\r\n  border-left: 3px double var(--table-foot-add-rule-border-color);\r\n}\r\n\r\n.dmn-decision-table-container tfoot.add-rule td.add-rule-add {\r\n  text-align: right;\r\n  padding-right: 4px;\r\n}\r\n\r\n.dmn-decision-table-container tfoot.add-rule tr td {\r\n  border-color: var(--table-foot-add-rule-border-color);\r\n  color: var(--table-foot-add-rule-color);\r\n}\r\n\r\n.dmn-decision-table-container tfoot.add-rule:hover td.input-cell + td.output-cell {\r\n  border-left-color: var(--table-cell-border-color);\r\n}\r\n\r\n.dmn-decision-table-container tfoot.add-rule:hover td {\r\n  border-color: var(--table-foot-add-rule-hover-border-color);\r\n  color: var(--table-foot-add-rule-hover-color);\r\n}\r\n\r\n/* end footer styles */\r\n\r\n/* content editable styles */\r\n\r\n.dmn-decision-table-container [contenteditable],\r\n.dmn-decision-table-container [tabindex] {\r\n  outline: none;\r\n}\r\n\r\n/* end content editable styles */\r\n\r\n/* decision table header */\r\n.dmn-decision-table-container .decision-table-header {\r\n  text-align: left;\r\n  padding: 10px;\r\n}\r\n\r\n.dmn-decision-table-container .decision-table-header * {\r\n  vertical-align: middle;\r\n}\r\n\r\n/* decision table properties */\r\n.dmn-decision-table-container .decision-table-properties {\r\n  display: flex;\r\n  color: var(--decision-table-properties-color);\r\n  border: 1px solid var(--table-cell-border-color);\r\n  background-color: var(--decision-table-background-color);\r\n  padding: 10px;\r\n  align-items: center;\r\n}\r\n\r\n.dmn-decision-table-container .decision-table-name {\r\n  position: relative;\r\n  display: block;\r\n  flex-grow: 1;\r\n  margin: 0;\r\n  width: 0;\r\n  min-width: 100px;\r\n  max-width: min-content;\r\n  font-size: 21px;\r\n  font-weight: normal;\r\n}\r\n\r\n.dmn-decision-table-container .decision-table-name:not(.editable),\r\n.dmn-decision-table-container .decision-table-name .content-editable {\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n}\r\n\r\n.dmn-decision-table-container .decision-table-name.focussed .content-editable {\r\n  text-overflow: unset;\r\n}\r\n\r\n.dmn-decision-table-container .decision-table-header-separator {\r\n  display: block;\r\n  height: 32px;\r\n  border-left: 2px solid var(--table-head-separator-color);\r\n  margin: 0 10px;\r\n}\r\n\r\n.dmn-decision-table-container .hit-policy {\r\n  display: block;\r\n}\r\n\r\n.dmn-decision-table-container .hit-policy-explanation {\r\n  margin-left: 5px;\r\n  color: var(--hit-policy-explanation-color);\r\n}\r\n\r\n/* end decision table properties */\r\n\r\n.dmn-decision-table-container thead .input-label,\r\n.dmn-decision-table-container thead .input-expression,\r\n.dmn-decision-table-container thead .output-label,\r\n.dmn-decision-table-container thead .output-name {\r\n  display: -webkit-box;\r\n  margin: 16px 6px;\r\n  font-size: 16px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  -webkit-line-clamp: 3;\r\n  -webkit-box-orient: vertical;\r\n}\r\n\r\n.dmn-decision-table-container thead .input-expression:empty::before {\r\n  content: 'Input';\r\n  opacity: 0.5;\r\n}\r\n\r\n.dmn-decision-table-container thead .output-name:empty::before {\r\n  content: 'Output';\r\n  opacity: 0.5;\r\n}\r\n\r\n.dmn-decision-table-container thead .input-variable,\r\n.dmn-decision-table-container thead .output-variable {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  text-align: right;\r\n}\r\n\r\n.dmn-decision-table-container thead .input-cell .clause,\r\n.dmn-decision-table-container thead .output-cell .clause {\r\n  font-size: 12px;\r\n  text-align: left;\r\n  color: var(--table-head-clause-color);\r\n}\r\n\r\n.dmn-decision-table-container thead .input-cell .input-variable,\r\n.dmn-decision-table-container thead .output-cell .output-variable {\r\n  font-size: 12px;\r\n  color: var(--table-head-variable-color);\r\n}\r\n\r\n/* actionable icon */\r\n\r\n.dmn-decision-table-container .action-icon {\r\n  border: none;\r\n  border-radius: 2px;\r\n  box-shadow: 0 0 0 2px var(--decision-table-background-color);\r\n  color: var(--action-icon-color);\r\n  background-color: var(--action-icon-background-color);\r\n  padding: 0;\r\n}\r\n\r\n.dmn-decision-table-container .create-inputs .action-icon,\r\n.dmn-decision-table-container .add-input .action-icon,\r\n.dmn-decision-table-container .add-output .action-icon {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 16px;\r\n  height: 16px;\r\n  margin: 0;\r\n  border-radius: 50%;\r\n  color: var(--add-column-icon-color);\r\n  background-color: var(--add-column-icon-background-color);\r\n  outline-offset: 4px;\r\n}\r\n\r\n.dmn-decision-table-container .actionable:hover .action-icon {\r\n  background-color: var(--action-icon-hover-background-color);\r\n  color: var(--action-icon-hover-color);\r\n}\r\n\r\n.dmn-decision-table-container .action-icon::before {\r\n  margin-left: 0.1em;\r\n  margin-right: 0.1em;\r\n}\r\n\r\n.dmn-decision-table-container .add-input,\r\n.dmn-decision-table-container .add-output {\r\n  position: absolute;\r\n  top: 50%;\r\n  right: -1px;\r\n  transform: translate(50%, -50%);\r\n  z-index: 2;\r\n  border-radius: 100%;\r\n  padding: 6px;\r\n}\r\n\r\n/* end actionable icon */\r\n\r\n/* view drd */\r\n.dmn-decision-table-container .view-drd {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.dmn-decision-table-container .view-drd .view-drd-button {\r\n  background: var(--view-drd-button-background-color);\r\n  padding: 8px;\r\n  border: solid 1px var(--view-drd-button-border-color);\r\n  border-radius: 2px;\r\n  font-size: 14px;\r\n  color: var(--view-drd-button-color);\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n}\r\n\r\n.dmn-decision-table-container .view-drd .view-drd-button:hover {\r\n  background: var(--view-drd-button-hover-background-color);\r\n}\r\n\r\n/* end view drd */\r\n\r\n/* simple mode */\r\n\r\n.dmn-decision-table-container .simple-mode-button {\r\n  color: var(--simple-mode-button-color);\r\n  background-color: var(--simple-mode-button-background-color);\r\n  position: absolute;\r\n  padding: 4px;\r\n  border-radius: 2px;\r\n  border: solid 1px var(--simple-mode-button-border-color);\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  z-index: 5;\r\n  opacity: 0.8;\r\n  box-shadow: 1px 1px 1px 1px var(--simple-mode-button-box-shadow-color);\r\n}\r\n\r\n.dmn-decision-table-container .simple-mode-button:hover {\r\n  opacity: 1;\r\n}\r\n\r\n.dmn-decision-table-container .simple-mode-button.disabled,\r\n.dmn-decision-table-container .simple-mode-button.disabled:hover {\r\n  color: var(--simple-mode-button-disabled-olor);\r\n}\r\n\r\n.dmn-decision-table-container .dms-input-duration-edit-row {\r\n  align-items: flex-start;\r\n}\r\n\r\n/* end simple mode  */\r\n\r\n/* badges */\r\n\r\n.dms-badge {\r\n  border-radius: 2px;\r\n  padding: 3px 6px;\r\n  font-size: 0.8em;\r\n  height: 19px;\r\n}\r\n\r\n.dms-badge-icon + .dms-badge-label {\r\n  margin-left: 3px;\r\n}\r\n\r\n.dms-badge.dmn-expression-language {\r\n  background: var(--dmn-expression-language-background-color);\r\n  color: var(--dmn-expression-language-color);\r\n}\r\n\r\n.dms-badge + .dms-badge {\r\n  margin-left: 3px;\r\n}\r\n\r\n.dmn-decision-table-container .dmn-expression-language .dms-badge-label {\r\n  display: none;\r\n}\r\n\r\n.dmn-decision-table-container .input-cell:hover .dmn-expression-language .dms-badge-label,\r\n.dmn-decision-table-container .output-cell:hover .dmn-expression-language .dms-badge-label {\r\n  display: inline-block;\r\n}\r\n\r\n.dmn-decision-table-container .input-editor .dmn-expression-language {\r\n  margin-top: 4px;\r\n  display: inline-block;\r\n}\r\n\r\n.dmn-decision-table-container .cell .dms-badge.dmn-expression-language {\r\n  z-index: -1;\r\n}\r\n\r\n.dmn-decision-table-container .cell:hover .dms-badge.dmn-expression-language {\r\n  background: var(--dmn-expression-language-hover-background-color);\r\n  z-index: 1;\r\n}\r\n\r\n/* cell expression language */\r\n\r\n.dmn-decision-table-container .cell .dmn-expression-language {\r\n  display: flex;\r\n  align-items: center;\r\n  position: absolute;\r\n  top: 2px;\r\n  right: 2px;\r\n  pointer-events: none;\r\n}\r\n\r\n/* end cell expression language */\r\n\r\n/* drag and drop */\r\n\r\n.dmn-decision-table-container .dragover::before {\r\n  content: '';\r\n  display: block;\r\n  position: absolute;\r\n  background-color: var(--drag-and-drop-drop-marker-color);\r\n  z-index: 2;\r\n  pointer-events: none;\r\n}\r\n\r\n.dmn-decision-table-container .dragover.top::before {\r\n  left: 0;\r\n  right: 0;\r\n  height: 5px;\r\n  top: 0;\r\n}\r\n\r\n.dmn-decision-table-container .dragover.right::before {\r\n  top: 0;\r\n  bottom: 0;\r\n  width: 5px;\r\n  right: 0;\r\n}\r\n\r\n.dmn-decision-table-container .dragover.bottom::before {\r\n  left: 0;\r\n  right: 0;\r\n  height: 5px;\r\n  bottom: 0;\r\n}\r\n\r\n.dmn-decision-table-container .dragover.left::before {\r\n  top: 0;\r\n  bottom: 0;\r\n  width: 5px;\r\n  left: 0;\r\n}\r\n\r\n.dmn-decision-table-container .dragged {\r\n  color: var(--drag-and-drop-drag-color);\r\n}\r\n\r\n/* cell description */\r\n\r\n.dmn-decision-table-container .description-indicator {\r\n  position: absolute;\r\n  top: 0;\r\n  right: -4px;\r\n  border-left: 4px solid transparent;\r\n  border-right: 4px solid transparent;\r\n  border-bottom: 4px solid var(--color-black);\r\n  transform: rotate(45deg);\r\n  transform-origin: top;\r\n}\r\n\r\n/* end cell description */\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
